import { Badge } from '@/components/ui/Badge'
import { cn } from '@/lib/cn'
import type { ProfileTier } from '../api'

// Styles + labels mirror the adverse_media.profile_tier enum
// (migration 0178). Keep ordered clear → blocked so the colour
// gradient telegraphs escalation.
const TIER_STYLES: Record<ProfileTier, string> = {
  clear: 'border-slate-200 bg-slate-50 text-slate-600',
  monitor: 'border-amber-200 bg-amber-50 text-amber-800',
  review: 'border-orange-300 bg-orange-50 text-orange-800',
  restricted: 'border-red-300 bg-red-50 text-red-800',
  blocked: 'border-red-500 bg-red-100 text-red-900',
}

const TIER_LABELS: Record<ProfileTier, string> = {
  clear: 'Clear',
  monitor: 'Monitor',
  review: 'Review',
  restricted: 'Restricted',
  blocked: 'Blocked',
}

export function TierBadge({ tier, className }: { tier: ProfileTier; className?: string }) {
  // Defensive fallback if the server enum widens ahead of a client
  // release.
  const label = TIER_LABELS[tier] ?? String(tier)
  const style = TIER_STYLES[tier] ?? 'border-slate-200 bg-white text-slate-700'
  return (
    <Badge className={cn('font-medium uppercase tracking-wide', style, className)}>
      {label}
    </Badge>
  )
}
